module.exports = __webpack_public_path__ + "img/DSC_2786.df63af02.png";